import { inject, Signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import {
    filter,
    map,
    of,
    shareReplay,
    switchMap
} from "rxjs";
import { VikariehanteringService } from "~app/features/administration/vikariehantering/vikariehantering.service";
import { AvtalMediatorService } from "~app/features/virkeskop/services/avtal-mediator.service";
import { PermissionFn } from "~app/role-permissions";
import { AuthenticationService } from "../services/authentication/authentication.service";

let cachedSignal: Signal<boolean>;

export const ansvarigVirkeskoparePermission: PermissionFn = () => {
    const avtalMediatorService = inject(AvtalMediatorService);
    const authenticationService = inject(AuthenticationService);
    const vikariehanteringService = inject(VikariehanteringService);

    const { userName } = authenticationService.getUserData();

    const applicable$ = avtalMediatorService.avtal$.pipe(
        filter(avtal => !!avtal?.current),
        map(avtal => avtal.current.ansvarigVirkeskopare.userName),
        switchMap(ansvarigVirkeskopare => {
            if (ansvarigVirkeskopare === userName) {
                return of(true);
            }
            // Om användaren inte är ansvarig virkesköpare:
            // Kolla om det finns något vikariat
            return vikariehanteringService.getVirkeskopare({
                anvandareUsername: ansvarigVirkeskopare,
                vikarieUsername: userName
            }).pipe(
                map(vikarier => vikarier.length > 0)
            );
        }),
        shareReplay(1)
    );

    // Cachar signalen så att inte fler androp till API görs varje gång ansvarigVirkeskoparePermission används
    if (!cachedSignal) {
        cachedSignal = toSignal(applicable$);
    }

    return cachedSignal;
};
